<div
  class="product-list-card"
  (click)="navigateToProductDetailPage('/products/' + productVariant.url_path)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="card-body">
    <a
      (click)="navigateToProductDetailPage('/products/' + productVariant.url_path)"
      [title]="productVariant.name"
    >
      <div class="product-image-container">
        <!-- Preview Image-->
        @if (previewImage) {
        <img [src]="previewImage" class="product-image" [alt]="productVariant.name" />
        } @else {
        <img [src]="IMAGE_URLS.noImagePlaceholder" class="image-placeholder" />
        }
      </div>
    </a>

    <div class="product-detail-section">
      <!-- Variant Color Viewer-->
      <!-- TODO variant viewer -->
      <base-variant-viewer
        [showImages]="showImages"
        (mouseEnterIndex)="setPreviewImage($event)"
        (mouseLeaveIndex)="clearPreviewImage()"
        [variants]="colorVariants"
      >
      </base-variant-viewer>

      <!-- Name and Price -->
      <a (click)="navigateToProductDetailPage('/products/' + productVariant.url_path)">
        <!-- Deal countdown-section -->
        @if (remainingTime()) { @if (remainingTime()!.remainingTime > 1000 &&
        storeConfiguration()?.is_deal_active) {
        <p class="countdown-info">
          {{ productDealCountDown.badge_message }}
          @if (remainingTime()!.daysToToday) {
          <strong>{{ remainingTime()!.daysToToday }}</strong>
          }{{ remainingTime()!.daysToToday > 0 ? 'd :' : '' }}
          @if (remainingTime()!.hoursToToday) {
          <strong>{{ remainingTime()!.hoursToToday }}</strong>
          }{{ remainingTime()!.hoursToToday > 0 ? 'h :' : '' }}
          {{ remainingTime()!.minutesToToday }}m : {{ remainingTime()!.secondsToToday }}s
        </p>
        } }

        <div class="product-title">
          <a
            (click)="navigateToProductDetailPage('/products/' + productVariant.url_path)"
            [ngClass]="{ 'mt-6': isDealAvailable, 'mt-10': !isDealAvailable }"
            >{{
              product().variant_group?.name || productVariant?.display_name || productVariant?.name
            }}</a
          >
        </div>
        <div class="product-price d-flex">
          @if (sellingPrice() < actualPrice()) {
          <span class="selling-price">{{ sellingPrice() | indianCurrency }}</span>
          <span class="actual-price">{{ actualPrice() | indianCurrency }}</span>
          } @else {
          <span class="product-price">{{ sellingPrice() | indianCurrency }}</span>
          }
        </div>
      </a>
    </div>

    <!-- Cash Points section -->
    @if (productVariant?.price_list && (productVariant.price_list | cashpoints) &&
    storeConfiguration()?.is_cashpoints_offer_active) {
    <div class="d-flex align-items-center cash-point-section">
      <p>Earn</p>
      <cash-point-svg width="18" height="18"></cash-point-svg>
      <p>
        {{ (productVariant.price_list | cashpoints) + ' CashPoints' }}
      </p>
    </div>
    }
  </div>
</div>
